<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteImageAttribution from '../../SiteImageAttribution.vue'
import SiteLink from '../../SiteLink.vue'
import type { AboutBlock } from '../../types'

defineProps<{ block: AboutBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container site:grid site:items-center site:gap-10 site:@min-[64rem]:grid-cols-2 site:@min-[64rem]:gap-20">
      <div :class="block.settings.imagePosition === 'right' ? undefined : 'site:@min-[64rem]:order-2'">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mt-6 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
        <SiteEditableText v-if="block.content.secondaryDescription" v-model="block.content.secondaryDescription" as="p" class="site:mt-4 site:leading-7 site:text-(--site-color-muted-text)" />
        <SiteLink v-if="block.content.action" :link="block.content.action" class="site-site-button site:mt-7">
          {{ block.content.action.label }}
        </SiteLink>
      </div>

      <div :class="block.settings.imagePosition === 'right' ? undefined : 'site:@min-[64rem]:order-1'">
        <figure
          v-if="block.content.image"
          class="site:relative site:aspect-[4/5] site:w-full site:overflow-hidden site:shadow-(--site-shadow-md)"
          :style="{ borderRadius: 'var(--site-radius-lg)' }"
        >
          <img :src="block.content.image.src" :alt="block.content.image.alt" class="site:h-full site:w-full site:object-cover" loading="lazy" />
          <SiteImageAttribution v-if="block.content.image.attribution" :image="block.content.image" class="site:absolute site:bottom-2 site:right-2" />
        </figure>
        <dl v-if="block.content.facts?.length" class="site:mt-5 site:grid site:grid-cols-2 site:gap-3">
          <div v-for="fact in block.content.facts" :key="fact.id" class="site:bg-(--site-color-surface) site:p-5" :style="{ borderRadius: 'var(--site-radius-md)' }">
            <SiteEditableText v-model="fact.value" as="dt" class="site-heading site:text-2xl site:font-bold site:text-(--site-color-primary)" />
            <SiteEditableText v-model="fact.label" as="dd" class="site:mt-1 site:text-sm site:text-(--site-color-muted-text)" />
          </div>
        </dl>
      </div>
    </div>
  </section>
</template>
